<template>
  <div>
    <a-modal
      :title="
        dataForm.id
          ? '编辑' + (dataForm.type == 1 ? '菜单' : '按钮')
          : '新增' + (dataForm.type == 1 ? '菜单' : '按钮')
      "
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      :keyboard="false"
      :maskClosable="false"
      @cancel="handleCancel"
      :getContainer="getContainer"
    >
      <a-form-model
        ref="ruleForm"
        :model="dataForm"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="类型" prop="type">
          <a-radio-group name="radioGroup" v-model="dataForm.type">
            <a-radio :value="1"> 菜单 </a-radio>
            <a-radio :value="2"> 按钮 </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="名称" prop="title">
          <a-input v-model="dataForm.title" placeholder="请输入名称" />
        </a-form-model-item>
        <a-form-model-item label="上级ID" prop="pid">
          <a-tree-select
            v-model="dataForm.pid"
            style="width: 100%"
            :tree-data="treeData"
            :replaceFields="{
              children: 'children',
              title: 'title',
              key: 'id',
              value: 'id',
            }"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            placeholder="Please select"
            allow-clear
            tree-default-expand-all
          >
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="name" prop="name" v-if="dataForm.type == 1">
          <a-input v-model="dataForm.name" placeholder="请输入name" />
        </a-form-model-item>
        <a-form-model-item label="icon" prop="icon" v-if="dataForm.type == 1">
          <a-input v-model="dataForm.icon" placeholder="请输入icon" />
        </a-form-model-item>
        <a-form-model-item label="路由" prop="path" v-if="dataForm.type == 1">
          <a-input v-model="dataForm.path" placeholder="请输入路由" />
        </a-form-model-item>
        <a-form-model-item
          label="文件路径"
          prop="component"
          v-if="dataForm.type == 1"
        >
          <a-input v-model="dataForm.component" placeholder="请输入文件路径" />
        </a-form-model-item>
        <a-form-model-item
          label="是否显示"
          prop="hiden"
          v-if="dataForm.type == 1"
          >
          <a-switch
            checked-children="显示"
            un-checked-children="不"
            :checked="dataForm.hiden == 1"
            @change="
              (e) => {
                dataForm.hiden = e ? 1 : 0;
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item label="是否缓存页面" v-if="dataForm.type == 1">
          <a-switch
            checked-children="缓存"
            un-checked-children="不"
            :checked="dataForm.keepalive === '1'"
            @change="
              (e) => {
                dataForm.keepalive = e ? '1' : '0';
              }
            "
          />
        </a-form-model-item>
        <a-form-model-item label="授权" prop="power">
          <a-input v-model="dataForm.power" placeholder="请输入授权" />
        </a-form-model-item>
        <a-form-model-item label="排序" prop="sort">
          <a-input-number
            style="width: 100%"
            v-model="dataForm.sort"
            :min="0"
          />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { addMenu, editMenu, menuInfo, menuAll } from "@/request/sys";
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
      replaceFields: { children: "children", title: "title", key: "id" },
      treeData: [],
      dataForm: {
        id: "",
        pid: "0",
        type: 1, //1菜单2按钮
        title: "",
        name: "",
        icon: "",
        path: "",
        component: "",
        power: "",
        sort: 0,
        hiden: 1, //0不显示1显示
        keepalive: "0", //是否缓存页面
      },
      bf: {},
      rules: {
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        pid: [{ required: true, message: "请选择上级ID", trigger: "change" }],
        title: [{ required: true, message: "请输入名称", trigger: "change" }],
        role_name: [
          { required: true, message: "请输入角色名称", trigger: "change" },
        ],
      },
    };
  },
  beforeMount() {
    this.bf = JSON.parse(JSON.stringify(this.dataForm));
  },
  methods: {
    init(id = "", project_id = "") {
      this.visible = true;
      if (id) {
        this.dataForm.id = id;
        this.getInfo();
      }
      this.dataForm.project_id = project_id;
      menuAll().then((res) => {
        this.treeData = [{ id: "0", title: "一级菜单", children: res.data }];
      });
    },
    getInfo() {
      menuInfo(this.dataForm.id).then((res) => {
        this.dataForm = { ...res.data };
      });
    },
    handleOk() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.confirmLoading = true;
          const fn = this.dataForm.id ? editMenu : addMenu;
          fn(this.dataForm)
            .then((res) => {
              this.$message.success(
                this.dataForm.id ? "修改成功" : "新增成功"
              );
              this.handleCancel();
              this.$emit("ok");
            })
            .finally(() => {
              let a = setTimeout(() => {
                clearTimeout(a);
                this.confirmLoading = false;
              }, 500);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleCancel() {
      console.log("Clicked cancel button");
      this.$refs.ruleForm.resetFields();
      this.dataForm = JSON.parse(JSON.stringify(this.bf));
      this.visible = false;
    },
    //切换角色
    roleChange(e) {
      this.dataForm.role_id = e;
    },
    getContainer(){
      return document.getElementById("bodyContnet")
    }
  },
};
</script>

<style></style>